import { render, staticRenderFns } from "./botonera_productos.vue?vue&type=template&id=7d351e6c&scoped=true"
import script from "./botonera_productos.vue?vue&type=script&lang=js"
export * from "./botonera_productos.vue?vue&type=script&lang=js"
import style0 from "./botonera_productos.vue?vue&type=style&index=0&id=7d351e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d351e6c",
  null
  
)

export default component.exports